import React, { useEffect, useState } from 'react';
import { Icon } from '../../../../foundations';
import { Text } from '../../../../foundations';
import { clsx } from 'clsx';
import styles from './AlertError.module.css';
import { Link } from '../../../../navigation/link/Link';
import { Trans, useTranslation } from 'react-i18next';
import { ApisError, errorApisTypes, errorKeyMapping } from '../../ApisForm.constants';
import { ApisErrorType, ErrorApisObject } from '../../ApisForm.model';
export interface AlertErrorProps {
	errors: ErrorApisObject[];
	id: string;
}

/**
 * Map an error type to a React component that displays an error message.
 * @param {ApisError} errorType - the type of error to map
 * @param {String} id - A unique identifier
 * @returns {React.Element} A React Text component containing a traslated error message and a link
 */
const mapErrorToComponents = (errorType: ApisErrorType, id: string) => {
	const { translationKey, linkPath } = errorKeyMapping[errorType as ApisError];
	const linkClear = `${linkPath}${id}`.trim();
	return (
		<Text key={errorType} font="verdana" as="p" size="lg-bold" className={styles.alert_description}>
			<Trans
				defaults={`alert-error-apis:${translationKey}`}
				components={{
					1: (
						<Link
							className={styles.alert_link_anchor}
							onClick={(e) => {
								e.preventDefault();
								const element = document.getElementById(linkClear);

								if (element) {
									element.scrollIntoView({ behavior: 'smooth', block: 'start' });
								}
							}}
						/>
					)
				}}
			/>
		</Text>
	);
};
export const AlertError: React.FC<AlertErrorProps> = ({ errors, id }) => {
	useTranslation(['alert-error-apis']);
	const [renderedErrors, setRenderedErrors] = useState<JSX.Element[]>([]);
	useEffect(() => {
		const newRenderedErrors = errors
			.filter((error: ErrorApisObject) => errorApisTypes.includes(error.code))
			.map((error: ErrorApisObject) => mapErrorToComponents(error.code, id));
		setRenderedErrors(newRenderedErrors);
	}, [errors, id]);

	return (
		<div role="alert" className={clsx(styles.alert_container)}>
			<header className={styles.alert_header}>
				<Icon name="alertas" className={styles.alert_icon} />
			</header>
			<div className={styles.alert_content}>
				{renderedErrors.length > 1 ? (
					<ul>
						{renderedErrors.map((errorcomponent, index) => (
							<li key={index}>{errorcomponent}</li>
						))}
					</ul>
				) : (
					<>{renderedErrors.length === 1 ? renderedErrors[0] : ''}</>
				)}

				<Text font="verdana" size="lg-regular" as="p" className={styles.alert_description}>
					<Trans
						defaults="alert-error-apis:ADDITIONAL_INFO"
						components={{
							1: (
								<Link
									data-testid="additional-info-link"
									link="https://www.iatatravelcentre.com/"
									target="__blank"
									className={styles.alert_link}
								/>
							)
						}}
					/>
				</Text>
			</div>
		</div>
	);
};
AlertError.displayName = 'AlertError';
